function DeleteSurveyModal({ draft, onConfirm, onCancel, deleteMessage }) {
  if (!draft) return null

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <form className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title">Delete NHSR</h2>
            <div className="btn btn-icon btn-sm ms-2" onClick={onCancel} aria-label="Close">
              <i className="fas fa-xmark text-gray-400 text-hover-gray-900 fs-1"></i>
            </div>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-stretch justify-content-between mb-4">
              <span>
                Last Saved{" "}
                {new Date(draft.updated_at).toLocaleString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </span>
            </div>
            <p>
              {deleteMessage}
            </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default DeleteSurveyModal
